import React, { memo } from 'react';
import { Form, Input, Button, Alert, Spin, Typography } from 'antd';
import { WhatsAppOutlined, LoadingOutlined, UserOutlined, MobileOutlined, ShopOutlined, CarOutlined, EnvironmentOutlined } from '@ant-design/icons';

const { Title } = Typography;

const OrderFormModal = memo(({ form, deliveryType, setDeliveryType, submitLoading, savingOrder, handleSubmitOrder }) => {
  return (
    <div className="order-form-container">
      <div className="order-confirmation">
        <Alert
          message="¡Importante!"
          description="Al enviar el pedido, será redirigido a WhatsApp para coordinar los detalles."
          type="info"
          showIcon
        />
      </div>
      <Form form={form} layout="vertical" onFinish={handleSubmitOrder} className="modern-form">
        <Form.Item name="name" rules={[{ required: true, message: 'Ingresa tu nombre' }]}>
          <Input prefix={<UserOutlined style={{ color: 'var(--primary)' }} />} placeholder="Nombre completo" className="modern-input" />
        </Form.Item>
        <Form.Item name="phone" rules={[{ required: true, message: 'Ingresa tu teléfono' }]}>
          <Input prefix={<MobileOutlined style={{ color: 'var(--primary)' }} />} placeholder="Número de teléfono" className="modern-input" />
        </Form.Item>
        <div className="delivery-type-selector">
          <Button type="button" className={`delivery-option ${deliveryType === 'recojo' ? 'active' : ''}`}
            onClick={() => setDeliveryType('recojo')}>
            <span className="delivery-icon"><ShopOutlined /></span>
            <span className="delivery-text">Recojo en tienda</span>
          </Button>
          <Button type="button" className={`delivery-option ${deliveryType === 'delivery' ? 'active' : ''}`}
            onClick={() => setDeliveryType('delivery')}>
            <span className="delivery-icon"><CarOutlined /></span>
            <span className="delivery-text">Envío a domicilio</span>
          </Button>
        </div>
        {deliveryType === 'delivery' && (
          <Form.Item name="address" rules={[{ required: true, message: 'Ingresa la dirección' }]}>
            <Input.TextArea
              prefix={<EnvironmentOutlined style={{ color: 'var(--primary)', marginTop: 4 }} />}
              placeholder="Dirección de entrega"
              className="modern-textarea"
              autoSize={{ minRows: 2, maxRows: 4 }}
            />
          </Form.Item>
        )}
        <Button type="primary" htmlType="submit" className="submit-button"
          icon={submitLoading ? <LoadingOutlined /> : <WhatsAppOutlined />}
          loading={submitLoading} disabled={submitLoading || savingOrder}>
          {submitLoading ? 'Procesando...' : 'Enviar pedido por WhatsApp'}
        </Button>
        {savingOrder && (
          <div className="saving-indicator">
            <Spin size="small" />
            <span>Guardando pedido...</span>
          </div>
        )}
      </Form>
    </div>
  );
});

export default OrderFormModal;
